<template>
  <section class="flex-full">
    <div class="header align-center">
      <h2>
        {{ $t('Reset password') }}
      </h2>
    </div>
    <div class="content align-center">
      <h4>
        {{ $t('For change your password please type a new password') }}
      </h4>
      <div class="reset">
        <form @submit.prevent="resetPassword" novalidate>
          <base-input
            class="mb10"
            type="password"
            name="password"
            v-model="password"
            @blur="$v.password.$touch()"
            :placeholder="$t('Password *')"
            :validations="[
              {
                condition: !$v.password.required && $v.password.$error,
                text: $t('Field is required.')
              },
              {
                condition: !$v.password.minLength && $v.password.$error,
                text: $t('Password must have at least 8 letters.')
              }
            ]"
          />
          <button-full class="mb20" type="submit" data-testid="loginSubmit">
            {{ $t('Set new password') }}
          </button-full>
        </form>
      </div>
    </div>
  </section>
</template>
<script>
import config from 'config'
import { processURLAddress } from '@vue-storefront/core/helpers'
import {minLength, required} from 'vuelidate/lib/validators'
import i18n from '@vue-storefront/i18n'

import ButtonFull from 'theme/components/theme/ButtonFull.vue'
const BaseInput = () => import(/* webpackChunkName: "vsf-base-input" */ 'theme/components/core/blocks/Form/BaseInput');

export default {
  name: 'ResetPassword',
  validations: {
    password: {
      minLength: minLength(8),
      required
    }
  },
  components: {
    BaseInput,
    ButtonFull
  },
  data () {
    return {
      email: '',
      rpToken: '',
      password: ''
    }
  },
  created () {
    this.rpToken = this.$route.params.token;
  },
  beforeMount () {
    fetch(processURLAddress(config.users.checkResetPasswordToken_endpoint), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        token: this.rpToken
      })
    }).then(res => {
      return res.json();
    }).then(result => {
      if (result.code !== 200) {
        this.$router.push('/');
        this.$store.dispatch('notification/spawnNotification', {
          type: 'error',
          message: this.$t(result.result),
          action1: { label: this.$t('OK') }
        })
      }
    })
  },
  methods: {
    resetPassword () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        this.$store.dispatch('notification/spawnNotification', {
          type: 'error',
          message: this.$t('Please fix the validation errors'),
          action1: { label: this.$t('OK') }
        })
        return
      }
      this.$bus.$emit('notification-progress-start', i18n.t('Changing the password ... '))
      fetch(processURLAddress(config.users.resetPasswordByToken_endpoint), {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          token: this.rpToken,
          password: this.password
        })
      }).then(res => res.json()).then(res => {
        if (res.code === 200) {
          this.$store.dispatch('notification/spawnNotification', {
            type: 'success',
            message: this.$t(res.result),
            action1: { label: this.$t('OK') }
          })
          this.$router.push('/');
        }
      }).catch(err => {
        console.log(err);
        this.$store.dispatch('notification/spawnNotification', {
          type: 'error',
          message: this.$t(err),
          action1: { label: this.$t('OK') }
        })
      })
      this.$bus.$emit('notification-progress-stop')
    }
  }
}
</script>
<style lang="scss" scoped>
.reset {
  padding-left: 27%;
  padding-right: 27%;
  @media (max-width: 400px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  @media (max-width: 540px) {
    padding-left: 50px;
    padding-right: 50px;
  }
}
</style>
